import { realtimeClient } from "./realtime-client";
import { RealtimeEvents } from "./realtime-events";


export class RealtimePublishMessage {
    static async execute(channelName: string, event: RealtimeEvents, message: string): Promise<void> {
        try {                        
            const client = realtimeClient(channelName);
            await client.channels.get(channelName).publish(event, message);
        } catch (error) {
            console.log("error publish message realtime", error);
            throw Error("Erro ao publicar mensagem no realtime");
        }
    }
}